/**
 * The way back from the session player to the Sessions view the user came
 * from (ZTA design evaluation F24): its filters, page and time range live in
 * the URL, so returning means returning to that URL.
 *
 * Sessions links into the player with `state: { fromSessions: true }`; then
 * Back is history's Back, which also restores scroll. Opened any other way (a
 * pasted link, a refresh after a new tab), the player sends the user to the
 * last Sessions query this tab saw.
 */
const KEY = 'zta.sessions.search';

export interface PlayerLinkState {
  fromSessions?: boolean;
}

export function rememberSessionsSearch(search: string): void {
  try {
    window.sessionStorage.setItem(KEY, search);
  } catch {
    // Storage blocked: the fallback is plain /sessions.
  }
}

export function sessionsReturnPath(): string {
  let search = '';
  try {
    search = window.sessionStorage.getItem(KEY) ?? '';
  } catch {
    search = '';
  }
  if (search && !search.startsWith('?')) search = `?${search}`;
  return `/sessions${search}`;
}

export function cameFromSessions(state: unknown): boolean {
  return !!(state && typeof state === 'object' && (state as PlayerLinkState).fromSessions);
}
